import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/main.scss";
import { defineCustomElements } from "@ionic/core/loader";
import VueApexCharts from "vue3-apexcharts";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import i18n from "./i18n";

// Inicializar Ionic Icons
defineCustomElements(window);

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);

app.use(VueApexCharts);
app.use(i18n);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.mount("#app");
